import { Pipe, PipeTransform } from '@angular/core';
import { Link } from 'src/core-lib/navigation/models/link.model';


@Pipe({
    name: 'hasNestedMenu'
})
export class HasNestedMenuPipe implements PipeTransform {
    transform(value: Link[]): boolean {
        return Array.isArray(value) && value.some(link => link?.children?.length > 0);
    }
}
